module.exports = __webpack_public_path__ + "static/media/recurring_cancelled.105a38b7.svg";